import omit from 'lodash/omit';
import { type OpenApiSchemaSection, type OpenApiSchemaSectionTemplate } from '#shared/api/schema';
import { type YandexKit } from '#shared/components/YandexKitProvider';

export const prepareConstructorSectionForSave = <T extends OpenApiSchemaSection>(
    section: T & { template?: OpenApiSchemaSectionTemplate },
    schema: ReturnType<YandexKit['getSettings']>
): Omit<T, 'template'> => {
    const { template: _template, ...sectionWithoutTemplate } = section;

    // Старые или вычисляемые модули не должны попадать в настройки секции без модулей.
    // Если схема недоступна, сохраняем настройки без изменений.
    if (
        schema?.properties &&
        !('modules' in schema.properties) &&
        section.settings &&
        typeof section.settings === 'object' &&
        'modules' in section.settings
    ) {
        return {
            ...sectionWithoutTemplate,
            settings: omit(section.settings, 'modules') as T['settings'],
        };
    }

    return sectionWithoutTemplate;
};
